// sensei-app/client/ui/AdminPlatformDashboard.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class AdminPlatformDashboard extends ComponentBase {
    constructor(config) {
        super(config);
        this.dashboardComponent = null;
    }

    async initialize() {
        await super.initialize();
        this.dashboardComponent = await this.createManagedComponent('Dashboard', null, {
            instanceId: `${this.config.instanceId}-platform-stats-dashboard`,
            role: "admin",
        });
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'admin-platform-dashboard-container h-100';
        }
        this.container.innerHTML = ''; 
        const dashboardElement = await this.dashboardComponent.render();
        this.container.appendChild(dashboardElement);
        
        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }
}